<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ViewerPill from '@/components/bop/ViewerPill.vue'
import { StepArticleVisibility } from '@/generated/graphql'

const props = defineProps<{
  visibilityMode: StepArticleVisibility
  showVisibilityToggles: boolean
  inStepGroup?: boolean
  canSaveViewport?: boolean
}>()

const emit = defineEmits<{
  'update:visibilityMode': [value: StepArticleVisibility]
  'save-viewport': []
}>()

const { t } = useI18n()

const toggleValue = computed(() =>
  props.visibilityMode === StepArticleVisibility.AllPrevious ? null : props.visibilityMode,
)
</script>

<template>
  <viewer-pill>
    <v-btn-toggle
      v-if="showVisibilityToggles"
      :model-value="toggleValue"
      density="compact"
      color="primary"
      variant="text"
      divided
      @update:model-value="
        (value: StepArticleVisibility | null) =>
          emit('update:visibilityMode', value ?? StepArticleVisibility.AllPrevious)
      "
    >
      <v-btn :value="StepArticleVisibility.HidePrevious" size="small" prepend-icon="visibility_off">
        {{ t('component.bopModelViewer.hidePreviousSteps') }}
      </v-btn>
      <v-btn
        v-if="inStepGroup"
        :value="StepArticleVisibility.ShowSubmodule"
        size="small"
        prepend-icon="account_tree"
      >
        {{ t('component.bopModelViewer.showSubmodule') }}
      </v-btn>
      <v-btn :value="StepArticleVisibility.ShowAll" size="small" prepend-icon="visibility">
        {{ t('component.bopModelViewer.showEverything') }}
      </v-btn>
    </v-btn-toggle>

    <v-divider v-if="showVisibilityToggles && canSaveViewport" vertical class="my-1" />

    <v-btn
      v-if="canSaveViewport"
      size="small"
      variant="text"
      color="primary"
      prepend-icon="photo_camera"
      @click="emit('save-viewport')"
    >
      {{ t('component.bopModelViewer.saveViewport') }}
    </v-btn>
  </viewer-pill>
</template>
